<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'transactions'" [businessName]="vm.businessName"
    [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>
<div class="container" *ngIf="!vm.isOpening">
    <div class="row pt-4 ">
        <div class="col-md-6 section-header">Water Usage</div>
        <div class="col-md-6 d-md-flex justify-content-end">
            <div *ngIf="!vm.isSearchOpen"><button class="btn btn-link" type="button"
                    (click)="openSearch()">Search</button></div>
            <div><button class="btn btn-link" type="button" (click)="addManual()">Add Manual</button></div>
            <div><button class="btn btn-link" type="button" (click)="addManualBulk()">Add Bulk</button></div>
        </div>
    </div>


    <div *ngIf="vm.isSearchOpen" class="pb-4 row">
        <div class="col-md-6 col-lg-5 col-xl-4">
            <div class="row">
                <div class="col">

                    <label>Date Range</label>
                    <div class="d-flex">
                        <div class="pr-2" style="width:50%;">
                          <input
                          autocomplete="off"
                            placeholder="Start Date"
                            type="text"
                            class="form-control form-control-sm pl-2 pr-2"
                            name="startDate"
                            ngbDatepicker
                            [(ngModel)]="vm.filter.startDateValue"
                            #dstartDate="ngbDatepicker"
                            (click)="dstartDate.toggle()">
                        </div>

                        <div class="pl-2" style="width:50%;">
                          <input
                          autocomplete="off"
                            type="text"
                            placeholder="End Date"
                            class="form-control form-control-sm"
                            name="endDate"
                            ngbDatepicker
                            [(ngModel)]="vm.filter.endDateValue"
                            #dendDate="ngbDatepicker"
                            (click)="dendDate.toggle()">
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col">
                    <label>Rego</label>
                    <input type="text" class="form-control form-control-sm" name="volume" placeholder="Rego Number"
                        [(ngModel)]="vm.filter.regoNo">
                </div>
            </div>
            <div class="row" *ngIf="false">
                <div class="col">
                    <label>Volume</label>
                    <input type="text" class="form-control form-control-sm" name="volume" placeholder="Litres"
                        [(ngModel)]="vm.filter.volume">
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Transaction Type</label>
                    <select class="form-control form-control-sm" name="transactionType"
                        [(ngModel)]="vm.filter.transactionType">
                        <option [ngValue]="''">All</option>
                        <option [ngValue]="'EMS'">EMS</option>
                        <option [ngValue]="'Logger'">Device</option>
                        <option [ngValue]="'WaterUsage'">Manual</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Location</label>
                    <input type="text" class="form-control form-control-sm" name="location" placeholder="Location"
                        [(ngModel)]="vm.filter.location">
                </div>
            </div>
            <div class="row pt-2">
                <div class="col text-right">
                    <button class="btn btn-link btn-sm" (click)="onChange($event)">
                        <i class="fa fa-search"></i> Search
                    </button>
                    <button  class="btn btn-link btn-sm" (click)="downloadCsv()">
                        <i class="fas fa-download"></i> Download
                    </button>
                    <button class="btn btn-link btn-sm" (click)="clearSearch()">Reset</button>
                    <button class="btn btn-link btn-sm" (click)="closeSearch()">Close</button>
                </div>
            </div>
        </div>
    </div>


    <div class="row">
        <div class="col px-0">
            <hr class="mt-0 mb-1" />
        </div>
    </div>

    <div class="row pb-1">
        <div class="col-md-2 font-weight-bold pl-2 pr-1 d-flex">
            <div>Date</div>
            <div class="pl-2"><a href="javascript:void(0)" (click)="onSort($event,'FillDate')">
                    <core-table-sorter [isSorted]="vm.filter.orderBy == 'FillDate'" [isDescending]="vm.filter.isDesc">
                    </core-table-sorter>
                </a></div>
        </div>
        <div class="col-md-1 font-weight-bold px-1 d-flex">
            <div>Vehicle</div>
            <div class="pl-2"> <a href="javascript:void(0)" (click)="onSort($event,'Rego')">
                    <core-table-sorter [isSorted]="vm.filter.orderBy == 'Rego'" [isDescending]="vm.filter.isDesc">
                    </core-table-sorter>
                </a></div>
        </div>
        <div class="col-md-1 font-weight-bold justify-content-end  d-flex">
            <div>Volume</div>
            <div class="pl-2"><a href="javascript:void(0)" (click)="onSort($event,'Volume')">
                    <core-table-sorter [isSorted]="vm.filter.orderBy == 'Volume'" [isDescending]="vm.filter.isDesc">
                    </core-table-sorter>
                </a></div>
        </div>
        <div class="col-md-1 font-weight-bold justify-content-end  d-flex">
            <div>Cost</div>
            <div class="pl-2"><a href="javascript:void(0)" (click)="onSort($event,'Cost')">
                    <core-table-sorter [isSorted]="vm.filter.orderBy == 'Cost'" [isDescending]="vm.filter.isDesc">
                    </core-table-sorter>
                </a></div>
        </div>
        <div class="col-md-2 font-weight-bold  px-1 d-flex">
            <div>Transaction Type</div>
            <div class="pl-2"> <a href="javascript:void(0)" (click)="onSort($event,'TransactionType')">
                    <core-table-sorter [isSorted]="vm.filter.orderBy == 'TransactionType'"
                        [isDescending]="vm.filter.isDesc">
                    </core-table-sorter>
                </a></div>

        </div>
        <div class="col-md-3 font-weight-bold  px-1 d-flex">
            <div>Location</div>
            <div class="pl-2"> <a href="javascript:void(0)" (click)="onSort($event,'Location')">
                    <core-table-sorter [isSorted]="vm.filter.orderBy == 'Location'" [isDescending]="vm.filter.isDesc">
                    </core-table-sorter>
                </a></div>

        </div>
        <div class="col-md-2 font-weight-bold  px-1 d-flex">
                <div>Status</div>
            </div>
    </div>

    <div class="row">
        <div class="col px-0">
            <hr class="mt-0 mb-1" />
        </div>
    </div>

    <div class="row pb-1" *ngFor="let t of vm.items; let i = index" [ngClass]="i%2==0 ? '' : 'bg-light'">
        <div class="col-md-2 pl-2 pr-1  text-truncate">{{t.fillDate | date:"dd/MM/yy HH:mm"}}</div>
        <div class="col-md-1 px-1 text-truncate">{{t.regoNo}}</div>
        <div class="col-md-1 pl-1 text-truncate text-right pr-3">{{t.volume}}</div>
        <div class="col-md-1 pl-1 text-truncate text-right pr-3">
            {{t.cost | currency:false:'symbol':'0.2'}}</div>
        <div class="col-md-2 px-1 text-truncate">{{t.transactionType}}</div>
        <div class="col-md-3 px-1 text-truncate">{{t.suburb}}</div>
        <div class="col-md-2 px-1 text-truncate d-flex">
            <div>{{t.status}}</div>
            <div *ngIf="t.transactionType=='Manual' && t.status=='New'"
            class="ml-auto"><a href="javascript:void()" (click)="editTransaction(t)"><i class="fas fa-edit"></i></a>
                </div>
            <div *ngIf="!!t.latitude && !!t.longitude" class="ml-auto">
                    <a href="javascript:void(0)" (click)="showOnMap(t)">
                        <i class="fas fa-map-marked-alt"></i>
                    </a>
            </div>

        </div>
        <div class="col-sm-12" *ngIf="t.attachments && t.attachments.length>0 ">
          <div class="pt-1">
            <div class="d-flex py-1" *ngFor="let f of t.attachments">

              <div><i class="fas fa-paperclip"></i></div>
              <div class="pl-2"><a [href]="fullUrl + f.fileId">{{f.fileName}}</a></div>
              <div class="pl-2"><i>{{f.comment}}</i></div>
            </div>
          </div>
        </div>
    </div>

    <div class="row" *ngIf="vm.totalCount==0">
        <div class="col">No water usage found</div>
    </div>

    <div class="row" *ngIf="vm.totalCount>0">
        <div class="col px-0">
            <hr class="mt-0 mb-1" />
        </div>
    </div>

    <div class="row">
        <div class="col pt-2">
            <core-pager [take]="vm.filter.take" [skip]="vm.filter.skip" [totalCount]="vm.totalCount"
                (navigate)="onPage($event)"></core-pager>
        </div>
    </div>

</div>
<cli-logger-location-modal #transactionLocationModal [id]="'transactionLocationModal'"></cli-logger-location-modal>
